<template>
  <div class="add-rfc is-flex is-centered">
    <div class="box">
      <form @submit.prevent="onSubmit">
        <h1 class="title is-4 has-text-primary">
          Agregar RFC
        </h1>

        <b-field
          label-for="rfc"
          label="RFC"
        >
          <b-input
            id="rfc"
            v-model="rfc"
            name="rfc"
            maxlength="150"
            icon-left="fingerprint"
            pattern="^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$"
            placeholder="XAXX010101000"
            :loading="loading"
            :disabled="loading"
            required
          />
        </b-field>

        <b-field
          label-for="name"
          label="Nombre o Razón Social"
        >
          <b-input
            id="name"
            v-model="name"
            name="name"
            class="is-uppercase"
            placeholder="Empresa SA de CV"
            maxlength="150"
            icon-left="domain"
            :loading="loading"
            :disabled="loading"
            required
          />
        </b-field>

        <b-field class="is-flex has-justify-content-end">
          <button class="button is-primary">
            Agregar RFC
          </button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { mapActions } from 'vuex';

export default {
  name: 'AddRFC',
  data() {
    return {
      loading: false,
      rfc: '',
      name: '',
    };
  },
  mounted() {
    const haveRFCAdd = this.$store.state.auth.packages
                       && this.$store.state.auth.packages.includes('RFCAdicional')
                       && this.$store.state.auth.companies.length <= 1;

    if (!haveRFCAdd) {
      this.$danger({ message: 'No tienes permisos de acceder.' });
      this.$router.push({ name: 'Dashboard' });
    }
  },
  methods: merge(
    mapActions({
      addRFC: 'auth/addRFC',
    }),
    {
      async onSubmit() {
        this.loading = true;

        try {
          await this.addRFC({
            rfc: this.rfc.toUpperCase(),
            name: this.name,
          });

          this.$router.replace({ name: 'Dashboard' });
        } catch ({ message }) {
          this.$danger({ message });
        }

        this.loading = false;
      },
    },
  ),
};
</script>

<style scoped>
.add-rfc {
  padding: 2rem;
}

.box {
  width: 250px;
}

.is-flex.has-justify-content-end {
  justify-content: flex-end;
}
</style>
